module.exports = __webpack_public_path__ + "static/media/refresh.1b4b7819.png";